import { useState } from "react";
import { MenuItem, Menu, Button } from "@mui/material";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import { MenuDataItem } from "./list";
import MenuElement from "./MenuElement";

interface MenuElementChildrenProps {
  item: MenuDataItem;
}

const MenuElementChildren = (props: MenuElementChildrenProps) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const item = props.item;
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <MenuItem>
      <Button
        aria-controls={open ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
        startIcon={open ? <ExpandLess /> : <ExpandMore />}
      >
        {item.label}
      </Button>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        {item.children &&
          item.children.map((submenuElement) =>
            submenuElement.link ? (
              <MenuElement
                key={submenuElement.entity}
                id={submenuElement.entity}
                label={submenuElement.label}
                url={submenuElement.link}
                blank={false}
              />
            ) : submenuElement.externalLink ? (
              <MenuElement
                key={submenuElement.entity}
                id={submenuElement.entity}
                label={submenuElement.label}
                url={submenuElement.externalLink}
                blank={true}
              />
            ) : (
              ""
            )
          )}
      </Menu>
    </MenuItem>
  );
};

export default MenuElementChildren;
